import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Container, CircularProgress } from "@mui/material";
import baseURL from "../../config";
import { FaEdit } from "react-icons/fa";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Pagination,
  Box,
  Typography,
  Modal,
} from "@mui/material";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Navbar from "../../Navbar/Navbar";
import { ToastContainer } from "react-toastify";


const ExecutiveVesselInfo = () => {
  const { id } = useParams();
const executiveId = id;
  const navigate = useNavigate(); // For navigation
  const [shipDetails, setShipDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);

  useEffect(() => {
    const fetchVesselDetails = async () => {
      try {
        const token = localStorage.getItem("token"); // or sessionStorage, depending on your app

const response = await axios.get(
  `${baseURL}/api/getvesseldetailbyexecutiveId/${id}`, 
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);

        
      } catch (err) {
        setError("Vessel not found.");
      } finally {
        setLoading(false);
      }
    };

    fetchVesselDetails();
  }, [id]);

  const handleOpenModal = (ship) => {
    if (ship) {
      const documents = Object.entries(ship)
        .filter(([key, value]) =>
          ["seagreement", "cdagreement", "pipolicydocument", "maritimelabourconvention", "fsdocument", "dmlcp1", "dmlc2"].includes(key) &&
          value
        )
        .map(([key, value]) => {
          const filePath = typeof value === "string" ? value : value?.filePath;
          return filePath
            ? {
              fileName: key, // Only the document key
              filePath: `${baseURL}/${filePath.replace(/\\/g, "/")}`,
            }
            : null;
        })
        .filter(Boolean);

      setSelectedDocuments(documents);
      setOpenModal(true); // Ensure the modal opens after setting state
    }
  };

  return (
    <>
      <Navbar />
      <div style={{ padding: "20px" }}>
        <h2>Vessel Table</h2>
        {/* <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
        <TextField
          label="Search by Vessel Name or IMO Number"
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{ maxWidth: 300, backgroundColor: "#f5f5f5" }}
        />

        <Link to={id ? `/vessel/${id}` : "/vessel"}>
          <button style={{ padding: "8px 16px", background: "#007bff", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer" }}>
            {id ? "Add Vessel" : "Add Vessel"}
          </button>
        </Link>
      </div> */}
        <Link to={id ? `/vessel/${id}` : "/vessel"}>
          <button style={{ padding: "8px 16px", background: "#007bff", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer" }}>
            {id ? "Add Vessel" : "Add Vessel"}
          </button>
        </Link>

        <TableContainer component={Paper} style={{ marginTop: "20px" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Ship Information</TableCell>
                <TableCell>Insurance Details</TableCell>
                <TableCell>Certificates</TableCell>
                <TableCell>Documents</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {shipDetails.map((ship, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Typography variant="body1"><strong>Name of Ship:</strong> {ship.vesselname}</Typography>
                      <Typography variant="body1"><strong>IMO Number:</strong> {ship.IMO_Number}</Typography>
                      <Typography variant="body1"><strong>Ship Type:</strong> {ship.vesseltype}</Typography>
                      <Typography variant="body1"><strong>Ship Flag:</strong> {ship.Flag}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Typography variant="body1"><strong>Pi Number:</strong> {ship.pipolicynumber}</Typography>
                      <Typography variant="body1"><strong>Policy Date:</strong> {new Date(ship.policydateofv).toLocaleDateString("en-GB")}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Typography variant="body1"><strong>MLC Certificate Number:</strong> {ship.mlcCert}</Typography>
                      <Typography variant="body1"><strong>MLC Expiry Date:</strong> {new Date(ship.mlcExpiryDate).toLocaleDateString("en-GB")}</Typography>
                      <Typography variant="body1"><strong>MLC Issue Date:</strong> {new Date(ship.mlcIssueDate).toLocaleDateString("en-GB")}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <IconButton onClick={() => handleOpenModal(ship)}>
                      <PictureAsPdfIcon sx={{ color: "red" }} />
                    </IconButton>
                  </TableCell>
                  <TableCell>
                    <IconButton onClick={() => navigate('/vessel', { state: { vessel: ship } })}>
                      <FaEdit style={{ color: "#1976d2" }} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90%", sm: "60%", md: "50%" },
            maxHeight: "80vh",
            bgcolor: "white",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
            overflowY: "auto",
          }}
        >
          <Typography
            variant="h6"
            gutterBottom
            sx={{ textAlign: "center", mb: 2, fontWeight: "bold" }}
          >
            Vessel Documents
          </Typography>
          {selectedDocuments.length > 0 ? (
            selectedDocuments
              .map(doc => ({
                ...doc,
                filePath: doc.filePath.includes("/Documents/")
                  ? doc.filePath
                  : doc.filePath.replace("/vesselupload/", "/Documents/vesselupload/")
              }))
              .map((doc, index) => (
                <Paper
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 2,
                    mb: 2,
                    boxShadow: 2,
                    borderRadius: 2,
                    transition: "0.3s",
                    "&:hover": { boxShadow: 4, bgcolor: "#f5f5f5" },
                  }}
                >
                  <Box display="flex" alignItems="center">
                    <PictureAsPdfIcon sx={{ color: "red", mr: 1 }} />
                    <Typography variant="body1">
                      {doc.fileName ? doc.fileName : "Unknown Document"}
                    </Typography>
                  </Box>

                  {/* Check if filePath exists and is valid */}
                  {doc.filePath && doc.filePath.trim() !== "" ? (
                    <Button
                      variant="contained"
                      color="primary"
                      href={doc.filePath}
                      target="_blank"
                      rel="noopener noreferrer"
                      size="small"
                      sx={{ textTransform: "none" }}
                    >
                      Download
                    </Button>
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      No File Available
                    </Typography>
                  )}
                </Paper>
              ))
          ) : (
            <Typography align="center" color="textSecondary">
              No documents available
            </Typography>
          )}




          <Box display="flex" justifyContent="center" mt={2}>
            <Button variant="contained" color="error" onClick={() => setOpenModal(false)}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>




      <ToastContainer />
    </>
  );
};

export default ExecutiveVesselInfo;
